import React, { useEffect, useRef } from 'react';
import Swiper from 'swiper';
import { Autoplay, EffectCoverflow } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-coverflow';

const FeaturedFriends = () => {
  const swiperRef = useRef(null);

  useEffect(() => {
    if (swiperRef.current) {
      const swiper = new Swiper(swiperRef.current, {
        modules: [Autoplay, EffectCoverflow],
        breakpoints: {
          0: { slidesPerView: 1 },
          576: { slidesPerView: 2 },
          992: { slidesPerView: 3 },
          1200: { slidesPerView: 3 },
        },
        effect: 'coverflow',
        coverflowEffect: {
          rotate: 0,
          stretch: 95,
          depth: 212,
          modifier: 1,
        },
        centeredSlides: true,
        loop: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
      });

      return () => swiper.destroy();
    }
  }, []);

  // Generate image numbers 13-23
  const images = Array.from({ length: 11 }, (_, i) => i + 13);

  return (
    <section className="destination-area position-relative overflow-hidden" id="destination-sec">
      <div className="container">
        <div className="title-area text-center">
          <span className="sub-title">New Friends</span>
          <h2 className="sec-title">Featured Friends of the Month</h2>
        </div>
        <div className="swiper th-slider destination-slider slider-drag-wrap" ref={swiperRef}>
          <div className="swiper-wrapper">
            {images.map((num) => (
              <div className="swiper-slide" key={num}>
                <div className="destination-box gsap-cursor">
                  <div className="destination-img">
                    <img
                      style={{ height: '600px', width: '100%', objectFit: 'cover' }}
                      src={`/assets/images/gallery/${num}.jpeg`}
                      alt="destination"
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturedFriends;